import React from 'react';

import { GridColDef } from '@mui/x-data-grid';
import i18n from '../../../translations/i18n';
import { Box } from '@mui/material';
import { AgentAvatar } from '../../../components/AgentAvatar';

export const columns: GridColDef[] = [
  {
    field: 'avatar',
    headerName: '',
    width: 60,
    sortable: false,
    filterable: false,
    resizable: false,
    renderCell: (params) => {
      const agent = params.row;

      return (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <AgentAvatar agent={agent} variant="table-row" />
        </Box>
      );
    },
  },
  {
    field: 'firstName',
    headerName: i18n.t('entities:common.firstName'),
    width: 130,
    hideable: false,
  },
  {
    field: 'lastName',
    headerName: i18n.t('entities:common.lastName'),
    width: 130,
    hideable: false,
  },
  {
    field: 'email',
    headerName: i18n.t('entities:common.email'),
    width: 300,
  },
];
